import { format } from "date-fns";
import React, { useContext, useEffect } from "react";
import { ResumeContext } from "../../../contexts/resumeContext";
import { iconMap } from "../../../utils/constants";
import {
  Bookmark,
  Briefcase,
  GraduationCap,
  Language,
  Laptop,
  Linkedin,
  Location,
  MagicWand,
  Mail,
  Phone,
  Star,
  StarFull,
  Team,
  Trophy,
  User,
} from "../../Icons/Icons";
import "./executive.css";

export default ({ info }) => {
  const { setColorOptions, activeColor, setActiveColor, resumeHeadings, setImgSupported } =
    useContext(ResumeContext);

  useEffect(() => {
    setColorOptions(["#aa8e74", '#2c66d7', '#f4bf6a', '#3a5280']);
    setActiveColor("#aa8e74");
    setImgSupported(true)
  }, []);

  const {
    personalDetails,
    educationDetails,
    professionalDetails,
    skills,
    social,
    misc,
  } = info;

  const education = Object.values(educationDetails || {});
  const work = Object.values(professionalDetails || {});
  const userSkills = Object.values(skills || {});
  const socialLinks = Object.values(social || {});
  const { courses, hobbies, languages, references, internships, activities, projects } =
    misc || {};
  return (
    <div className="executive">
      <div className="executive__body">
        <div className="executive__body__left" style={{backgroundColor: `${activeColor}18`}}>
          <div className="section">
            {personalDetails?.userImage && (
              <img className="dev__avatar" src={personalDetails?.userImage} />
            )}
          </div>
          <div className="section">
            <h3 className="section__title" style={{color: activeColor}}>
              <span className="section__title__icon" style={{backgroundColor: activeColor}}>
                <Phone />
              </span>{" "}
              Contact
            </h3>
            <div className="row">
              <div className="contact__icons">
                <div className="contact__icons__bg" style={{backgroundColor: activeColor}}></div>
                {personalDetails?.email && <span><Mail /> 
                  <a href={`mailto:${personalDetails?.email?.trim()}`}>
                    {personalDetails?.email?.trim()}
                  </a></span>}
                {personalDetails?.phone && <span><Phone /> <a href={`tel:${personalDetails?.phone?.trim()}`}>
                    {personalDetails?.phone?.trim()}
                  </a></span>}
                {(personalDetails?.address?.trim() ||
                  personalDetails?.postalCode?.trim()) && <span><Location /> {personalDetails?.address?.trim()}
                  {personalDetails?.postalCode?.trim() && " - "}
                  {personalDetails?.postalCode?.trim()}</span>}
                {socialLinks.map((link, ix) =>
                  link.link !== ""
                    ? <span>{iconMap[link.label?.toLowerCase()] || link.label} <a href={link.link} target="_blank">
                        {link.link}
                      </a></span>
                    : null
                )}
              </div>
            </div>
          </div>
          {personalDetails?.summary && <div className="section">
            <h3 className="section__title" style={{color: activeColor}}>
              <span className="section__title__icon" style={{backgroundColor: activeColor}}>
                <User />
              </span>
              {resumeHeadings?.SUM}
            </h3>
            <div
              className="section__content"
              dangerouslySetInnerHTML={{ __html: personalDetails?.summary }}
            />
          </div>}

          {!!userSkills?.length && <div className="section">
            <h3 className="section__title" style={{color: activeColor}}>
              <span className="section__title__icon" style={{backgroundColor: activeColor}}>
                <Star />
              </span>
              {resumeHeadings?.SK}
            </h3>
            <div className="section__content">
              {userSkills.map((skill, ix) => (
                <span className="executive__skill" key={skill + ix} style={{backgroundColor: activeColor}}>
                  {skill}
                </span>
              ))}
            </div>
          </div>}

          {!!hobbies?.length && (
            <div className="section">
              <h3 className="section__title" style={{color: activeColor}}>
                <span className="section__title__icon" style={{backgroundColor: activeColor}}>
                  <MagicWand />
                </span>{" "}
                {resumeHeadings?.HOB}
              </h3>
              <div className="section__content">{hobbies}</div>
            </div>
          )}
          {!!languages?.length && (
            <div className="section">
              <h3 className="section__title" style={{color: activeColor}}>
                <span className="section__title__icon" style={{backgroundColor: activeColor}}>
                  <Language />
                </span>
                {resumeHeadings?.LAN}
              </h3>
              <div className="section__content">{languages}</div>
            </div>
          )}
        </div>
        <div className="executive__body__right">
          <div className="executive__personal_details">
            <h1 className="executive__name">
              {personalDetails?.firstName?.trim()}{" "}
              {personalDetails?.lastName?.trim()}
            </h1>
            <h2 className="executive__job_title">{personalDetails?.jobTitle}</h2>
          </div>
          {!!work?.length && <div className="section">
            <h3 className="section__title" style={{color: activeColor}}>
              <span className="section__title__icon" style={{backgroundColor: activeColor}}>
                <Briefcase />
              </span>
              {resumeHeadings?.WE}
            </h3>
            {work.map((exp, ix) => (
              <div className="sub__section">
                <p className="m-0">
                  <b>{exp.jobTitle}</b>, {exp.company}
                </p>
                <p style={{marginTop: '0.5em'}}>
                  {exp.location},{" "}
                  <em>
                    (
                    {exp.startDate && (
                      <>{format(new Date(exp.startDate), "MMM yyyy")}</>
                    )}{" "}
                    {exp.endDate && (
                     <>- {exp.endDate === "Present" ? "Present" : format(new Date(exp.endDate), "MMM yyyy")}</>
                    )}
                    )
                  </em>
                </p>
                <div dangerouslySetInnerHTML={{ __html: exp.description }} />
              </div>
            ))}
          </div>}

          {!!internships?.length && (
            <div className="section">
              <h3 className="section__title" style={{color: activeColor}}>
                <span className="section__title__icon" style={{backgroundColor: activeColor}}>
                  <Laptop />
                </span>
                {resumeHeadings?.INT}
              </h3>
              {internships.map((intern, ix) => (
                <div className="sub__section" key={`intern_${ix}`}>
                  <p className="m-0">
                    <b>{intern.jobTitle}</b>, {intern.company}
                  </p>
                  <p style={{marginTop:'0.5em'}}>
                    {intern.location},{" "}
                    <em>
                      (
                      {intern.startDate && (
                        <>{format(new Date(intern.startDate), "MMM yyyy")}</>
                      )}{" "}
                      {intern.endDate && (
                        <>- {format(new Date(intern.endDate), "MMM yyyy")}</>
                      )}
                      )
                    </em>
                  </p>
                  <div
                    dangerouslySetInnerHTML={{ __html: intern.description }}
                  />
                </div>
              ))}
            </div>
          )}

          {!!education?.length && <div className="section">
            <h3 className="section__title" style={{color: activeColor}}>
              <span className="section__title__icon" style={{backgroundColor: activeColor}}>
                <GraduationCap />
              </span>
              {resumeHeadings?.AD}
            </h3>
            {education?.map((ed, ix) => (
              <div className="sub__section">
                <p className="m-0">
                  <b>{ed.degree}</b>, {ed.institute}
                </p>
                <p style={{marginTop: '0.5em'}}>
                  {ed.location}{" "}
                  <em>
                    (
                    {ed.startDate && (
                      <>{format(new Date(ed.startDate), "MMM yyyy")}</>
                    )}{" "}
                    {ed.endDate && (
                      <>- {format(new Date(ed.endDate), "MMM yyyy")}</>
                    )}
                    )
                  </em>
                </p>
                <div dangerouslySetInnerHTML={{ __html: ed.description }} />
              </div>
            ))}
          </div>}

          {!!projects?.length && <div className="section">
            <h3 className="section__title" style={{color: activeColor}}>
              <span className="section__title__icon" style={{backgroundColor: activeColor}}>
                <StarFull />
              </span>
              {resumeHeadings?.PRO}
            </h3>
            {projects?.map((pro, ix) => (
              <div className="sub__section">
                <p className="m-0">
                  <b>{pro.title}</b>, {pro.company}
                </p>
                <p style={{marginTop: '0.5em'}}>
                  <em>
                    (
                    {pro.startDate && (
                      <>{format(new Date(pro.startDate), "MMM yyyy")}</>
                    )}{" "}
                    {pro.endDate && (
                      <>- {format(new Date(pro.endDate), "MMM yyyy")}</>
                    )}
                    )
                  </em>
                </p>
                <div dangerouslySetInnerHTML={{ __html: pro.description }} />
              </div>
            ))}
          </div>}

          {!!courses?.length && (
            <div className="section">
              <h3 className="section__title" style={{color: activeColor}}>
                <span className="section__title__icon" style={{backgroundColor: activeColor}}>
                  <Bookmark />
                </span>
                {resumeHeadings?.CR}
              </h3>
              {courses?.map((course, ix) => (
                <div className="sub__section">
                  <p className="m-0">
                    <b>{course.name}</b>
                  </p>
                  <p style={{marginTop: '0.5em'}}>
                    {course.institution},&nbsp;
                    <em>
                      (
                      {course.startDate && (
                        <>{format(new Date(course.startDate), "MMM yyyy")}</>
                      )}{" "}
                      {course.endDate && (
                        <>- {format(new Date(course.endDate), "MMM yyyy")}</>
                      )}
                      )
                    </em>
                  </p>
                </div>
              ))}
            </div>
          )}

          {!!activities?.length && (
            <div className="section">
              <h3 className="section__title" style={{color: activeColor}}>
                <span className="section__title__icon" style={{backgroundColor: activeColor}}>
                  <Trophy />
                </span>
                {resumeHeadings?.ACT}
              </h3>
              {activities?.map((activity, ix) => (
                <div className="sub__section" key={ix}>
                  <p className="m-0">
                    <b>{activity.title}</b>, {activity.institution}
                  </p>
                  <p style={{marginTop: '0.5em'}}>
                    {activity.location}{" "}
                    <em>
                      (
                      {activity.startDate && (
                        <>{format(new Date(activity.startDate), "MMM yyyy")}</>
                      )}{" "}
                      {activity.endDate && (
                        <>- {format(new Date(activity.endDate), "MMM yyyy")}</>
                      )}
                      )
                    </em>
                  </p>
                  <div
                    dangerouslySetInnerHTML={{ __html: activity.description }}
                  />
                </div>
              ))}
            </div>
          )}

        {!!references?.length && (
            <div className="section">
              <h3 className="section__title" style={{color: activeColor}}>
                <span className="section__title__icon" style={{backgroundColor: activeColor}}>
                  <Team />
                </span>
                {resumeHeadings?.REF}
              </h3>
              {references?.map((ref, ix) => (
                <div className="sub__section" key={ix}>
                  <p className="m-0">
                    <b>{ref.name}</b>, {ref.institution}
                  </p>
                  <p style={{marginTop: '0.5em'}}>
                    {ref.email}{ref.phone && <>,{' '}{ref.phone}</>}
                  </p>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
